module.exports = __webpack_public_path__ + "static/media/step-indicator-1.77d6a09d.svg";